import React, {useState} from 'react';
import styles from './styles';
// import {colors} from '../defaultSettings';
import {ToggleSwitchV2, CheckCircle, Button} from '@xpertdox_js/xdcomponents';
// -- TODO: this should be passed down to datatable not imported!
import SettingObj from '../../UserManagement/userManagementSetting';
import { trackActivity } from '../../../utils/activityTracker'
import { UserContext } from '../../../Context/UserContext'
import { InstanceContext } from '../../../InstanceContext'

const InnerCell = props => {
  // styles
  const contentStyles = {
    ...styles.innerCell,
    width: props.width,
    // borderColor: props.dropdown ? colors.opacShade : colors.innerBorder,
    minHeight: props.height + 'px',
    borderLeft: props.first ? 0 : styles.innerCell.borderLeft,
    borderBottom: props.dropdown ? 'none' : styles.innerCell.borderBottom
  };
  const [displayValue, setDisplayValue] = useState(false);
  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)
  // const [hover, setHover] = useState(false);
  // const [displayActive, setDisplayActive] = useState(false);
  // const timeoutRef = React.useRef(null);
  // const clearTimeoutRef = () => {
  //   clearTimeout(timeoutRef.current);
  //   timeoutRef.current = null;
  // }
  // if (hover && timeoutRef.current === null)
  //   timeoutRef.current = setTimeout(() => setDisplayActive(true), 500);
  // if (!hover && timeoutRef.current && displayActive) {
  //   setDisplayActive(false);
  //   clearTimeoutRef();
  // }
  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }

  const formatString = value => value.length > props.charCount
      ? value.slice(0, props.charCount - 2) + '...'
      : value;

  const formatArray = value => {
      const overrideHeight = value.length * 18 + 16;
      if (props.height !== overrideHeight && props.height < overrideHeight) props.setHeight(props.index, overrideHeight)

      return(
        <ul id={props.id} style={styles.listCell}>
          {value.map((listItem, i) => {
            const itemValue = props.settings.listKey
              ? listItem[props.settings.listKey]
              : listItem
            return(
              <li id={props.id} key={i} style={{marginBottom: '2px'}}>
                {SettingObj.app[itemValue] ? SettingObj.app[itemValue] : itemValue}
              </li>
            );
          })}
        </ul>
      );
  };

  const formatObject = value => (
    <ul style={styles.listCell}>
    {Object.keys(value).map((key, i) =>
      <li key={key}>
        <b>{key}:</b>{value[key]}
      </li>
    )}
    </ul>
  );

  const formatContacts = (dataObj, type) => {
    let returnValue = <div>
      {
        [type].map((c, key) => {
          return <div key={key} id={props.id}>
            {dataObj[c] && dataObj[c].length !== 0 &&
              <ul id={props.id} style={{listStyleType: 'none', paddingLeft: 0}}>
              {dataObj[c] && dataObj[c].map((p,k) => <li id={props.id} key={k}>{p && p.name}</li>)}
              </ul>
            }
          </div>
        })
      }
    </div>;
    setDisplayValue(returnValue);
  }

  // format value based on value type
  if(
    props.settings
    && ['contacts', 'pcrc'].includes(props.settings.key)
    && !displayValue
  ) formatContacts(props.data, props.settings.key === 'contacts' ? 'primary_contacts' : 'pcrc')
  else if (props.value && !displayValue) {
    let value = props.value;
    switch(typeof props.value) {
      case 'string':
      value = formatString(props.value);
      break;
      case 'object':
      value = Array.isArray(props.value)
      ? formatArray(props.value)
      : formatObject(props.value);
      break;
      default: value = props.value;
    }
    setDisplayValue(value);
  }


  // cell action if declared in settings
  let action = null;
  if (props.settings && props.settings.action) {
    action = (value) => {
      handleActivityLogUpdate(`InnerCell.action`)
      props.actions[props.settings.action](
        value,
        props.settings.key,
        props.data,
        props.controller
      );
    }
  }

  // cell content container absolute position
  const needsFill = (props.settings &&
    (props.settings.type === 'switch' || props.settings.type === 'button'))
    || props.groupCell || displayValue === false;
  const innerCellStyles = {
    ...styles.innerCellContent,
    width: needsFill ? '100%' : 'auto',
    height: needsFill ? '100%' : 'auto',
  }

  // grouping function
  const handleGrouping = param => {
    !props.controller.group.includes(props.dataID)
      ? props.controller.addToGroup(param)
      : props.controller.removeFromGroup(param);
    props.controller.render();
    // console.log(props.controller.group)
  }


  return(
    <div
      style={contentStyles}
      id={!props.groupCell ? props.id : null}
    >
      <div style={innerCellStyles} id={!props.groupCell ? props.id : null}>
        {!props.groupCell && props.settings.type
          ? (props.settings.type === 'switch'
            ? <div style={styles.absCenter}><ToggleSwitchV2
              condition={props.value}
              setter={action}
              styles={styles.cellSwitch}
            /></div>
            : props.settings.type === 'button'
            ? <Button
                onClick={action}
                styles={styles.buttonCell}
                hoverStyles={styles.buttonCellHov}
                activeStyles={styles.buttonCellAct}
                focusStyles={styles.buttonCellFoc}
              >
                <div style={styles.absCenter}>{props.settings.icon || displayValue}</div>
              </Button>
            : displayValue
            )
          : props.groupCell

          ? <div style={styles.absCenter}><CheckCircle
              condition={props.controller.group.includes(props.dataID)}
              setter={handleGrouping}
              setterParam={props.dataID}
            /></div>

          : (displayValue === false ? <span style={styles.absCenter}>---</span> : displayValue) 
        }
      </div>
    </div>
  )

}

export default InnerCell;
